module.exports = __webpack_public_path__ + "assets/allstar-70c62c3e5eadb49de4df5a84421a7bca.svg";